<template>
    <div>
        <div v-if="active" class="alert-box custom-alert-box">
            <div class="alert-box-body custom-alert-box-body">
                <slot name="alert-text"></slot>
                <br><br>
            </div>
            <div class="alert-box-button custom-alert-box-button">
                <slot name="alert-buttons"></slot>
            </div>
        </div>
        <div v-if="active" class="modalbg-dummy custom-alert-backdrop" v-on:click="backClick"></div>
    </div>
</template>
<script>
module.exports = {
    name:'customAlertComponent',
    props:{
        active:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        backClick: function(){
            this.$emit('outside_click');
        }
    }
}
</script>
<style scoped>
.custom-alert-box {
    top: 50%;
    left: 50%;
    width: min(560px, calc(100vw - 32px));
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 48px);
    padding: 24px;
    margin: 0;
    transform: translate(-50%, -50%);
    border: 1px solid #d8d8d8;
    border-radius: 12px;
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.16);
    overflow-y: auto;
}

.custom-alert-box-body {
    text-align: center;
}

.custom-alert-box-button {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
}

.custom-alert-backdrop {
    inset: 0;
}

@media (max-width: 767px) {
    .custom-alert-box {
        width: calc(100vw - 24px);
        max-width: calc(100vw - 24px);
        max-height: calc(100vh - 32px);
        padding: 20px 16px;
    }
}
</style>
